import { render, staticRenderFns } from "./ParticipantOtherInformations.vue?vue&type=template&id=0d359af0"
import script from "./ParticipantOtherInformations.vue?vue&type=script&lang=ts"
export * from "./ParticipantOtherInformations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports